// removed by extract-text-webpack-plugin
module.exports = {"logo":"styles-module__logo___2Yn9B"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/Logo/styles.module.css
// module id = 400
// module chunks = 0